module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/ribbon.d347e819.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/ribbon.png
// module id = 2542
// module chunks = 11